module.exports = __webpack_public_path__ + "static/media/apply.3269de4e.svg";